var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.306,
    height: 30.801,
    viewBox: "0 0 18.306 30.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "smartphone",
    d: "M118.8,27.017a.469.469,0,0,1-.469.469h-5.952a.469.469,0,0,1,0-.938h5.952A.469.469,0,0,1,118.8,27.017Zm5.333-24.429V27.414A2.714,2.714,0,0,1,121.311,30H109.445a2.714,2.714,0,0,1-2.82-2.588V2.588A2.714,2.714,0,0,1,109.445,0h11.866A2.715,2.715,0,0,1,124.131,2.588Zm-.938,0A1.78,1.78,0,0,0,121.311.938h-2.787V1.962a.469.469,0,0,1-.469.469H112.39a.469.469,0,0,1-.469-.469V.938h-2.477a1.78,1.78,0,0,0-1.882,1.651V27.414a1.779,1.779,0,0,0,1.882,1.65h11.866a1.78,1.78,0,0,0,1.882-1.65Z",
    transform: "translate(-106.225 0.4)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.d9d9ab995daf877cef6902f09b0ecf18.svg";
export { ForwardRef as ReactComponent };